export default __webpack_public_path__ + "assets/ghost.a159ab.svg";